/** Superficie pública única de shared/. Fuera de shared/ importar solo desde aquí. */

export { getErrorMessage } from './errorMessage';
export { privacyPolicyUrl, termsOfServiceUrl, supportEmail, openLegalUrl, accountDeletionHelpUrl } from './legalUrls';
export { getLastSelectedBranchId, setLastSelectedBranchId, clearLastSelectedBranchId, getLastPosPaymentMethodId, setLastPosPaymentMethodId } from './localPrefs';
export { isPlaywrightE2E, isPlaywrightE2EBridge } from './playwrightE2e';
export type { PlaywrightE2EPosScan } from './playwrightE2e';
export * from './connectivity/public-api';
export * from './navigation/public-api';
export * from './data/public-api';
export * from './localDb';
export * from './dev/public-api';
export * from './filters/public-api';
export * from './format/public-api';
export * from './layout/public-api';
export * from './modals/public-api';
export * from './numeric/public-api';
export * from './ports/public-api';
export * from './product-search/public-api';
export * from './supabase/public-api';
export * from './surface-cards/public-api';
export * from './theme/public-api';
export * from './ticket/public-api';
export * from './ui/public-api';

// Sentry ops capture (#844)
export { captureOpsFailure } from './sentry/sentryOps';
export type { CaptureOpsFailureParams, OpsWritePath } from './sentry/sentryOps';
export { presentUnexpectedFailure, isUnexpectedFailureHandled } from './sentry/presentUnexpectedFailure';
export { reportUserVisibleFailure } from './sentry/sentryUser';
export {
  isLegacyProductCategoryHint,
  remapLegacyProductCategoryId,
  remapProductSyncPayload,
  productQueueErrorLooksStuck,
} from './domain/legacyCategoryId';
